'use strict';

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var errCode = require('err-code');

var _require = require('../errors'),
    messages = _require.messages,
    codes = _require.codes;

var _require2 = require('./utils'),
    storeAddresses = _require2.storeAddresses,
    uniquePeers = _require2.uniquePeers,
    requirePeers = _require2.requirePeers,
    maybeLimitSource = _require2.maybeLimitSource;

var merge = require('it-merge');

var _require3 = require('it-pipe'),
    pipe = _require3.pipe;
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 * @typedef {import('multiformats/cid').CID} CID
 * @typedef {import('libp2p-interfaces/src/content-routing/types').ContentRouting} ContentRoutingModule
 */

/**
 * @typedef {Object} GetData
 * @property {PeerId} from
 * @property {Uint8Array} val
 */


var ContentRouting = /*#__PURE__*/function () {
  /**
   * @class
   * @param {import('..')} libp2p
   */
  function ContentRouting(libp2p) {
    _classCallCheck(this, ContentRouting);

    this.libp2p = libp2p;
    /** @type {ContentRoutingModule[]} */

    this.routers = libp2p._modules.contentRouting || [];
    this.dht = libp2p._dht; // If we have the dht, add it to the available content routers

    if (this.dht && libp2p._config.dht.enabled) {
      this.routers.push(this.dht);
    }
  }
  /**
   * Iterates over all content routers in parallel to find providers of the given key.
   *
   * @param {CID} key - The CID key of the content to find
   * @param {object} [options]
   * @param {number} [options.timeout] - How long the query should run
   * @param {number} [options.maxNumProviders] - maximum number of providers to find
   * @returns {AsyncIterable<{ id: PeerId, multiaddrs: Multiaddr[] }>}
   */


  _createClass(ContentRouting, [{
    key: "findProviders",
    value: function findProviders(key) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.routers.length) {
                  _context.next = 2;
                  break;
                }

                throw errCode(new Error('No content this.routers available'), 'NO_ROUTERS_AVAILABLE');

              case 2:
                return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(pipe(merge.apply(void 0, _toConsumableArray(_this.routers.map(function (router) {
                  return router.findProviders(key, options);
                }))), function (source) {
                  return storeAddresses(source, _this.libp2p.peerStore);
                }, function (source) {
                  return uniquePeers(source);
                }, function (source) {
                  return maybeLimitSource(source, options.maxNumProviders);
                }, function (source) {
                  return requirePeers(source);
                })), _awaitAsyncGenerator), "t0", 3);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
    /**
     * Iterates over all content routers in parallel to notify it is
     * a provider of the given key.
     *
     * @param {CID} key - The CID key of the content to find
     * @returns {Promise<void>}
     */

  }, {
    key: "provide",
    value: function () {
      var _provide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.routers.length) {
                  _context2.next = 2;
                  break;
                }

                throw errCode(new Error('No content routers available'), 'NO_ROUTERS_AVAILABLE');

              case 2:
                _context2.next = 4;
                return Promise.all(this.routers.map(function (router) {
                  return router.provide(key);
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function provide(_x) {
        return _provide.apply(this, arguments);
      }

      return provide;
    }()
    /**
     * Store the given key/value pair in the DHT.
     *
     * @param {Uint8Array} key
     * @param {Uint8Array} value
     * @param {Object} [options] - put options
     * @param {number} [options.minPeers] - minimum number of peers required to successfully put
     * @returns {Promise<void>}
     */

  }, {
    key: "put",
    value: function put(key, value, options) {
      if (!this.libp2p.isStarted() || !this.dht.isStarted) {
        throw errCode(new Error(messages.NOT_STARTED_YET), codes.DHT_NOT_STARTED);
      }

      return this.dht.put(key, value, options);
    }
    /**
     * Get the value to the given key.
     * Times out after 1 minute by default.
     *
     * @param {Uint8Array} key
     * @param {Object} [options] - get options
     * @param {number} [options.timeout] - optional timeout (default: 60000)
     * @returns {Promise<GetData>}
     */

  }, {
    key: "get",
    value: function get(key, options) {
      if (!this.libp2p.isStarted() || !this.dht.isStarted) {
        throw errCode(new Error(messages.NOT_STARTED_YET), codes.DHT_NOT_STARTED);
      }

      return this.dht.get(key, options);
    }
    /**
     * Get the `n` values to the given key without sorting.
     *
     * @param {Uint8Array} key
     * @param {number} nVals
     * @param {Object} [options] - get options
     * @param {number} [options.timeout] - optional timeout (default: 60000)
     * @returns {Promise<GetData[]>}
     */

  }, {
    key: "getMany",
    value: function () {
      var _getMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, nVals, options) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!this.libp2p.isStarted() || !this.dht.isStarted)) {
                  _context3.next = 2;
                  break;
                }

                throw errCode(new Error(messages.NOT_STARTED_YET), codes.DHT_NOT_STARTED);

              case 2:
                return _context3.abrupt("return", this.dht.getMany(key, nVals, options));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getMany(_x2, _x3, _x4) {
        return _getMany.apply(this, arguments);
      }

      return getMany;
    }()
  }]);

  return ContentRouting;
}();

module.exports = ContentRouting;